import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const CalculatorQuestions = [
  {
    q_id: "0",
    q_title: "Move-in date",
    q_description: () => {
      return "When does the tenant plan to move into the property?";
    },
    node_type: "node",
    a_type: "date",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (!answerVal) {
        return false;
      }
      return true;
    },
    q_invalid_answer_help_text: "Please select a move-in date",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Monthly rent",
    q_description: () => {
      return "What is the monthly rent for the property?";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false;
      }
      return true;
    },
    q_invalid_answer_help_text: "Please enter a valid rent amount",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation? Ex. 'Prorated rent for 123 Main St'";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (!answerVal || answerVal.length === 0) {
        return false;
      }
      return true;
    },
    q_invalid_answer_help_text: "Please enter a calculation name",
    a_error: false,
  },
  {
    q_id: "0000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations. You can also enter a state, zip or nothing, since this field is optional.";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (!answerVal && !answerVal.length > 0) {
        return false;
      }
      return true;
    },
    q_invalid_answer_help_text: "Please enter or select an address",
    a_error: false,
  },
];

export default CalculatorQuestions;
